import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from '@/core/api/base-service';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { MedicoTelemedicinaHistoricoResponse, MedicoTelemedicinaResponse, TipoTelemedicinaResponse } from '@/core/api/sicom-api/registro/medico/telemedicina/telemedicina.model';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import { environment } from '../../../../../../../environments/environment';
import { SICOM_PATHS } from 'src/sicom-paths';

@Injectable({ providedIn: 'root' })
export class TelemedicinaService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.telemedicina;
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    buscar(params: Pessoa, context?: HttpContext): Observable<MedicoTelemedicinaResponse[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf);
        return this.http.get<MedicoTelemedicinaResponse[]>(`${this.PATH}/consulta`, { params: httpParams, context });
    }

    buscarHistorico(params: Pessoa, context?: HttpContext): Observable<MedicoTelemedicinaHistoricoResponse[]> {
        const httpParams = new HttpParams().set('id', params.id).set('uf', params.uf);
        return this.http.get<MedicoTelemedicinaHistoricoResponse[]>(`${this.PATH}/historico/consulta`, { params: httpParams, context });
    }

    listarTiposTelemedicina(context?: HttpContext): Observable<TipoTelemedicinaResponse[]> {
        return this.http.get<TipoTelemedicinaResponse[]>(`${this.PATH}/tipos`, { context });
    }

    inserirTelemedicina(body: MedicoTelemedicinaResponse, context?: HttpContext): Observable<void> {
        return this.http.post<void>(`${this.PATH}`, body, { context });
    }

    atualizarTelemedicina(body: MedicoTelemedicinaResponse, context?: HttpContext): Observable<void> {
        return this.http.put<void>(`${this.PATH}`, body, { context });
    }
}
